/**
 * Structure dependencies
 */
import Backbone from 'backbone';
import HeaderView from './views/headerView';
import SidebarView from './views/sidebarView';
import ChatView from '~/views/chatView';
import TickettView from '~/views/ticketView';
import EventHub from '~/eventHub';

/**
 * Theme depedencies
 */
import ProgressService from "~/services/progressService";
import "bootstrap";

/**
 * AppView: Object that represents the web application
 * @constructor
 * @extends Backbone.View
 * @type {*}
 */
var AppView = Backbone.View.extend({

  /**
   * [regions supported website regions, which represent HTML DOM nested components]
   * @type {Object}
   */
  regions: {
    header: null, // Header view (static)
    filter: null, // Filter view (static)
    content: null, // Website content (dynamic)
    'content-row': null, // Website lower content (dynamic)
    footer: null // Footer view (not implemented yet)
  },
  header: null, // Header legend
  $containers: {},

  /**
   * Initialiaze the view object
   * Fill in the regions, sets the header and builds the sidebar
   */
  initialize: function() {
    // Starts up the NProgress widget
    ProgressService.initialize();

    // For evey container integrate the inner region
    for (var regionName in this.regions) {
      this.$containers[regionName] = this.$(`.region-${regionName}`);
      var $inner = this.$containers[regionName].find('.region-inner');
      if ($inner.length) {
        this.$containers[regionName] = $inner;
      }
    }

    // Load the header view and define the header attribute
    this.headerView = new HeaderView({
      el: this.$('.top_nav')
    });
    this.header = $('.top_nav');
    // Load the sidebar view
    this.sidebarView = new SidebarView({
      el: this.$('.sidebar')
    });
    this.chatView = new ChatView({
      el: this.$('.chat')
    });
	this.tickettView = new TickettView({
      el: this.$('#troubleshootingsModalContainer')
    });
    // Attach the required events
    this.attachEvents();
  },


  /**
   * Attach the events to the view
   */
  attachEvents: function() {
    var self = this;
    // Refresh the content height
    this.listenTo(EventHub, 'app:refreshContentHeight', this.refreshContentHeight);

    // Set the header name
    // TODO: fix typo => header-tittle
    this.listenTo(EventHub, 'header:setName', vista => {
      $('title')[0].text = 'SM - '+vista;
      self.header.find('#header-tittle').text(vista);
    });
  },

  /**
   * Render the view components
   */
  render: function() {
    // Render the header and the sidebar
    this.headerView.render();
    this.sidebarView.render();
    this.chatView.render();
	this.tickettView.render();

    // Render the static elements sequentially
    this.$body = $('body');
    this.$footer = this.$('footer');
    this.$sidebarFooter = this.$('.sidebar-footer');
    this.$leftCol = this.$('.left_col');
    this.$rightCol = this.$('.right_col');
    this.$navMenu = this.$('.nav_menu');

    // Recompute content when resizing

    this.refreshContentHeight();
  },

  /**
   * Switch between different layout types
   * a. default (sidebar, header, footer, main content)
   * b. full-width layout type with grey background (used on login page)
   * @param  {[type]} layoutType ['default' or 'fullwidth-light']
   */
  updateLayoutType: function(layoutType) {
    if (layoutType !== this.layoutType) {
      this.layoutType = layoutType;
      switch (layoutType) {
        case 'default':
          this.$body.removeClass('login nav-sm').addClass('nav-md');
          this.headerView.$el.removeClass('hidden');
          this.sidebarView.$el.removeClass('hidden');
          this.chatView.$el.removeClass('hidden');
          this.$footer.removeClass('hidden');
          break;
        case 'fullwidth-light':
          this.$body.removeClass('nav-sm nav-md').addClass('login');
          this.headerView.$el.addClass('hidden');
          this.sidebarView.$el.addClass('hidden');
          this.chatView.$el.addClass('hidden');
          this.$footer.addClass('hidden');
          break;
      }
    }
  },

  /**
   * Refresh content height to not leave blank space at the bottom of the page
   * @function refreshContentHeight
   */
  refreshContentHeight: function() {
    // Reset height
    this.$rightCol.css('min-height', $(window).height());

    var bodyHeight = this.$body.outerHeight(),
      footerHeight = this.$body.hasClass('footer_fixed') ? 0 : this.$footer.height(),

      leftColHeight = this.$leftCol.eq(1).height() + this.$sidebarFooter.height(),
      contentHeight = bodyHeight < leftColHeight ? leftColHeight : bodyHeight;

    // Normalize content
    contentHeight -= this.$navMenu.height() + footerHeight;

    // Apply the height
    this.$rightCol.css('min-height', contentHeight);
  },

  /**
   * [Render the layout according to the regions definitions provided]
   * @param  {[type]} regions    [description]
   * @param  {[type]} layoutType [description]
   * @return {[type]}            [description]
   */
  renderLayout: function(regions, layoutType) {
    // this logic is pretty simple and currently doesn't show/hide regions or add/delete class names
    // (this can be necessary and can be easily added)

    // Firstable,  remove all old views
    for (var regionName in this.regions) {
      var views = this.regions[regionName];
      if (views) {
        if (_.isArray(views)) {
          _.each(views, (view) => {
            view.remove();
          });
        } else {
          views.remove();
        }
        this.regions[regionName] = null;
      }
    }
    // Update the type of layout, fallback to default
    this.updateLayoutType(layoutType || 'default');

    // Then, render the new views
    for (var regionName in this.regions) {
      if (regions[regionName]) {
        this.regions[regionName] = regions[regionName];
        this.$containers[regionName].removeClass('hidden');
        if (_.isArray(regions[regionName])) {
          _.each(regions[regionName], (view) => {
            this.$containers[regionName].append(view.render().$el);
          });
        } else {
          this.$containers[regionName].append(regions[regionName].render().$el);
        }
      } else {
        this.$containers[regionName].addClass('hidden');
      }
    }
  },
});

// AppView exported elements (AppView class)
export default AppView;
